import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  header: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  paper: { padding: theme.spacing(2), marginBottom: theme.spacing(2) },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2)
  },
  summary: { marginTop: theme.spacing(2) }
}))
